import {select2} from 'select2';

export default class Account {

    constructor($view) {
        this.$view = $view;
//        this.bind();
    }

    bind() {
        this.$view.find("select[name=favoris_shop]").select2();
    }
}


// WEBPACK FOOTER //
// ./public/frontend/js/components/Account.js